import React from 'react';
import PropTypes from 'prop-types';
import './FormGroup.css';

const classNames = (className, { vertical }) => {
  const names = [];
  if (className) {
    names.push(className);
  }
  if (vertical) {
    names.push('vertical');
  }
  return names.join(' ');
};

const FormGroup = ({ children, vertical }) => (
  <div className={classNames('FormGroup', { vertical })}>
    {children}
  </div>
);

FormGroup.propTypes = {
  children: PropTypes.node.isRequired,
  vertical: PropTypes.bool,
};

FormGroup.defaultProps = {
  vertical: false,
};

const InputGroup = ({ children }) => (
  <div className="InputGroup">
    {children}
  </div>
);

InputGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

FormGroup.InputGroup = InputGroup;

export default FormGroup;



// WEBPACK FOOTER //
// ./src/components/FormGroup.jsx